export default "__VITE_ASSET__CbfZ0cL1__"